module.exports = __webpack_public_path__ + "static/media/2_cheese_cake.ccae17e8.jpg";